import api from './api';

const communicationUrl = '/communication-overview';

export function getRims(instructionId: number) {
  return api.get(`${communicationUrl}/rims/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getSvs(instructionId: number) {
  return api.get(`${communicationUrl}/svs/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getImages(instructionId: number) {
  return api.get(`${communicationUrl}/images/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getDaccaCalculations(caseCode: string) {
  return api.get(`${communicationUrl}/dacca-calculations/${caseCode}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getOtherAttachments(instructionId: number) {
  return api.get(`${communicationUrl}/other-attachment/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getCommentOrReports(instructionId: number) {
  return api.get(`${communicationUrl}/comment-report/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function sendRims(svsIdList: string) {
  return api.post(`${communicationUrl}/send-rims`, {
    ids: svsIdList,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function deleteRims(rimIdList: string) {
  return api.post(`${communicationUrl}/delete-rims`, {
    ids: rimIdList,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function deleteHonoraryNotes(honoraryNoteIdList: string) {
  return api.post(`${communicationUrl}/delete-honorary-notes`, {
    ids: honoraryNoteIdList,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function sendSvs(svsIdList: string) {
  return api.post(`${communicationUrl}/send-svs`, {
    ids: svsIdList,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function deleteSvs(svsIdList: string) {
  return api.post(`${communicationUrl}/delete-svs`, {
    ids: svsIdList,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function sendImages(idList: string, instructionId: number) {
  return api.post(`${communicationUrl}/send-image`, {
    ids: idList,
    instructionId: instructionId
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function sendOtherAttachments(idList: string, instructionId: number) {
  return api.post(`${communicationUrl}/send-other-attachment`, {
    ids: idList,
    instructionId: instructionId,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function sendComments(idList: string) {
  return api.post(`${communicationUrl}/send-comment`, {
    ids: idList,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function sendReports(idList: string, instructionId: number) {
  return api.post(`${communicationUrl}/send-report`, {
    ids: idList,
    instructionId: instructionId,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function getAskedAmount(instructionId: number) {
  return api.get(`${communicationUrl}/asked-amount/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function setAskedAmount(instructionId: number, amount: string) {
  return api.post(`${communicationUrl}/set-asked-amount`, {
    instructionId: instructionId,
    amount: amount,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function getHonoraryNotes(instructionId: number) {
  return api.get(`${communicationUrl}/honorary-note/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function sendHonoraryNotes(idList: string) {
  return api.post(`${communicationUrl}/send-honorary-note`, {
    ids: idList,
  }).catch(err => {
    console.error(err);
    return err;
  });
}
